import Breadcrumb from "@/components/Breadcrumb";
import Hero2 from "@/components/Hero2";
import ConsultantCard from "@/components/ConsultantCard";
import { consultant_helper } from "@/helpers/consultant_helper";
import { useState } from "react";
import SeoHead from "@/components/SeoHead";
import classes from "./styles.module.scss";
import { Cookies } from "@/components";
import { SourceFlowHead } from "@sourceflow-uk/sourceflow-head";
import metaObject from "@/../.sourceflow/metadata.json";

export default function MeetTheTeamPage({ consultants }) {
  const [formData, setFormData] = useState({
    filterSpecialism: "",
    filterLocation: "",
  });

  const handleInputChange = (fieldName, value) => {
    setFormData({
      ...formData,
      [fieldName]: value,
    });
  };

  const specialismsOptions = [
    { label: "Select Specialisms", value: "" },
    ...Array.from(new Set(consultants.flatMap((consultant) => consultant.specialisms)))
      .filter((specialism) => specialism !== undefined)
      .map((specialism) => ({ label: specialism, value: specialism })),
  ];

  const locationOptions = [
    { label: "Select Locations", value: "" },
    ...Array.from(new Set(consultants.map((consultant) => consultant.locations)))
      .filter((location) => location !== undefined)
      .map((location) => ({ label: location, value: location })),
  ];

  let filteredConsultants = consultants.filter((consultant) =>
    formData.filterSpecialism ? consultant.specialisms?.includes(formData.filterSpecialism) : true,
  );

  filteredConsultants = filteredConsultants.filter((consultant) =>
    formData.filterLocation ? consultant.locations === formData.filterLocation : true,
  );

  return (
    <>
      <div style={{ marginTop: "120px" }}>
        <SeoHead
          page_name={`Xcede Technology Recruitment Specialists | Meet the team`}
          canonical_link={`https://www.xcede.com/meet-the-team`}
        />
        <div className={classes.heroSection}>
          <div className={classes.hero}>
            <div style={{ marginBottom: "30px" }}>
              <Breadcrumb label="Meet The Team" />
            </div>
            <Hero2 highlight="meet the team" scroll={false} />
          </div>
          <div className={classes.filters}>
            <h6>FILTER BY</h6>
            <select
              value={formData.filterSpecialism}
              className={classes.select}
              style={formData.filterSpecialism == "" ? { color: "grey" } : {}}
              onChange={(e) => handleInputChange("filterSpecialism", e.target.value)}
            >
              {specialismsOptions.map((option) => (
                <option key={option.value} value={option.value}>
                  {option.label}
                </option>
              ))}
            </select>
            <select
              value={formData.filterLocation}
              className={classes.select}
              style={formData.filterLocation == "" ? { color: "grey" } : {}}
              onChange={(e) => handleInputChange("filterLocation", e.target.value)}
            >
              {locationOptions.map((option) => (
                <option key={option.value} value={option.value}>
                  {option.label}
                </option>
              ))}
            </select>
          </div>
        </div>
        <div className={classes.consultants_cont}>
          <div className={classes.consultants}>
            {filteredConsultants.map((consultant, index) => {
              return <ConsultantCard key={index} consultant={consultant} />;
            })}
          </div>
        </div>
      </div>
    </>
  );
}

export async function getStaticProps({}) {
  const all_consultants = consultant_helper.fetch();

  return {
    props: {
      consultants: all_consultants,
    },
  };
}
